// The API's error "message" can be a string, a list, or an object of field
// messages (validation errors). This turns any of those into strings to show.
export function messagesFrom(message) {
  if (message == null) return [];
  if (typeof message === "string") return [message];
  if (Array.isArray(message)) return message.flatMap(messagesFrom);
  if (typeof message === "object") return Object.values(message).flatMap(messagesFrom);
  return [String(message)];
}
